/**
 * Breadcrumbs Component
 * Navigation breadcrumbs with link support
 * Auto-generated from route or custom items
 */

import React from 'react';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import { HomeOutlined } from '@ant-design/icons';

/**
 * Breadcrumbs Component
 *
 * @param {Array} items - Breadcrumb items [{label, path}]
 * @param {boolean} showHome - Show home icon as first item (default: true)
 * @param {string} homePath - Home path (default: '/')
 * @param {Object} style - Additional styles
 */
function Breadcrumbs({
  items = [],
  showHome = true,
  homePath = '/',
  style = {},
}) {
  // Build breadcrumb items
  const breadcrumbItems = [
    ...(showHome ? [{
      title: <Link to={homePath}><HomeOutlined /></Link>,
    }] : []),
    ...items.map((item, index) => ({
      title: item.path && index < items.length - 1
        ? <Link to={item.path}>{item.label}</Link>
        : item.label,
    })),
  ];

  return (
    <Breadcrumb
      items={breadcrumbItems}
      style={style}
    />
  );
}

export default Breadcrumbs;
